import { ReactComponent as Error } from '@/assets/svgs/icon-error-message-exclamation.svg';
import { ReactComponent as IconInformation } from '@/assets/svgs/info-circle.svg';
import Button from '@/components/Button';
import DexLeftComponent from '@/components/DexLeftComponent';
import csatKeys from '@/constants/configuration/csat-keys.json';
import { useNavigate, useQuery } from '@/lib/router-dom';
import { login } from '@/redux/actions/auth.js';
import { getDexConfig } from '@/utils/get-dex-config';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const AuthRedirect = () => {

	const { dex, env } = getEnvAndDex();

	const query = useQuery();
	const authCode = query.get("code");
	const redirectURL = encodeURI(window.location.origin + `/auth/redirect`);
	const [authRedirectErrorMessage, _setAuthRedirectErrorMessage] = useState()
	const { goTo } = useNavigate();
	const dispatch = useDispatch()

	useEffect(() => {
		const body = {
			code: authCode,
			redirectUrl: redirectURL
		}
		loginHandler(goTo, body)
	}, [])

	async function loginHandler(goTo, body) {
		try {
			await dispatch(login(goTo, body, "authLogin"))
		}
		catch (e) {
			// Removing only required keys from local storage due to CSAT Integration
			localStorage.removeItem('userEmail');
			localStorage.removeItem('lockedTime');
			localStorage.removeItem('lockedAccount');
			localStorage.removeItem('isTableView');
			localStorage.removeItem('isListView');

			// Remove CSAT Integration
			const csatWidgetBaseUrl = csatKeys[env]?.CSAT_WIDGET_BASE_URL;
			const csatSpaceKey = csatKeys[env]?.CSAT_SPACE_KEY;
			if (document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=onUserSnapLoad"]`)) {
				document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=onUserSnapLoad"]`).remove();
			}
			goTo('/login', { message: e.message });
		}
	}

	/*=================================================
		MultiDex
	/================================================*/
	const { dexName } = getDexConfig(dex);

	return (
		<div className='layout-login'>
			<DexLeftComponent />
			<div className="layout-login__right">
				<div className="login-box">
					<div className='login-box__title'>Welcome to { dexName } Pitstop Portal</div>
					<div className="authRedirect-box__title">Hold on!</div>
					{authRedirectErrorMessage && (
						<div className='login-box__form__col--error'>
							<Error /> <span className='t--required'>{authRedirectErrorMessage}</span>
						</div>
					)}
					<div className='authRedirect-box__title-display'>
						<IconInformation className='authRedirect-box__title-icon' />
						<div className="authRedirect-box__desc">
							Your organisation has enabled single sign-on authentication. <br />
							You will be redirected to your organisation's sign-in process.
						</div>
					</div>
					<div className="forgetPassword-box__form">
						<div className="forgetPassword-box__form__action">
							<Button text="···" className="authRedirect-box__form__action__top" type="submit" maxWidth="168" full round loading={true} />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AuthRedirect
